module.exports = __webpack_public_path__ + "static/media/Homepad.aef236df.jpg";